import * as Company from '@web/contracts/Company';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type Attributes = Company.NextGen.Attributes;
type SocialPlatforms = Company.NextGen.Social.Platform;

export type State = Nullable<{
  selectedAttr: Attributes;
  selectedSocialPlatform: SocialPlatforms;
  selectedTechnoGroup: string;
}>;

export interface Action {
  setAttr: (attr: Attributes) => void;
  setSocialPlatform: (platform: SocialPlatforms) => void;
  setTechnoGroup: (group: string) => void;
}

/**
 * Store to maintain the currently selected company's NextGen data
 */
const useNextGen = create<State & Action>()(
  devtools(
    immer((set) => ({
      selectedAttr: null,
      selectedSocialPlatform: null,
      selectedTechnoGroup: null,
      selectedWebTrafficGroup: null,
      setAttr: (attr) => set({ selectedAttr: attr }, false, { type: 'SET_NEXT_GEN_ATTRIBUTE' }),
      setSocialPlatform: (platform) =>
        set({ selectedSocialPlatform: platform }, false, { type: 'SET_SOCIAL_PLATFORM' }),
      setTechnoGroup: (group) => set({ selectedTechnoGroup: group }, false, { type: 'SET_TECHNOGRAPHICS_GROUP' }),
    })),
    {
      store: 'NextGen',
    },
  ),
);

export { useNextGen };
